var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDollarCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M12 11c-2 0-2-.626-2-1 0-.484.701-1 2-1 1.185 0 1.386.638 1.4 1.018l1-.018h1c0-1.026-.666-2.469-2.4-2.879V6.012h-2v1.073C9.029 7.416 8 8.712 8 10c0 1.12.52 3 4 3 2 0 2 .676 2 1 0 .415-.62 1-2 1-1.841 0-1.989-.857-2-1H8c0 .918.661 2.553 3 2.92V18h2v-1.085c1.971-.33 3-1.627 3-2.915 0-1.12-.52-3-4-3"
})));
export default SvgDollarCircle;